import React from 'react';

export default function ComingSoon({ icon = '🚧', title = 'Coming soon', description }) {
  return (
    <div className="empty-state">
      <div className="empty-icon">{icon}</div>
      <div className="empty-title">{title}</div>
      {description && <p className="empty-description">{description}</p>}
    </div>
  );
}
